import ProductPages from "./ProductPages";

const productsLayout = (props) => {
  return (
    <div>
      
      <ProductPages />
    </div>
  );
};
export default productsLayout;
